import type SessionService from 'scaleflow/services/session';

/** What the Cognito authenticator stores under `session.data.authenticated.details`. */
export interface AuthDetails {
  email?: string;
  sub?: string;
  accessToken?: string;
  idToken?: string;
  refreshToken?: string;
}

/**
 * `ember-simple-auth` types `session.data` as an open index signature, so the
 * Cognito details are read through this one cast instead of at every call site.
 */
export function authDetails(session: SessionService): AuthDetails | undefined {
  const data = session.data as
    { authenticated?: { details?: AuthDetails } } | undefined;
  return data?.authenticated?.details;
}
